import { useAtomValue } from 'jotai';

import { Typography } from '@gds/Typography/Typography';

import { calculationAtom } from '../../Atoms/Calculation.atom';
import { selectedProductIdAtom } from '../../Atoms/SelectedProductId.atom';
import type { CalculatorMessages } from '../FinancingCalculator/Calculator.messages';

import styles from './TermsAndConditions.module.css';

export type TermsAndConditionsProps = {
  strings: CalculatorMessages;
};

export const TermsAndConditions = ({ strings }: TermsAndConditionsProps) => {
  const selectedProductId = useAtomValue(selectedProductIdAtom);

  const calculation = useAtomValue(calculationAtom)!;
  const selectedProduct = selectedProductId && calculation?.products?.[selectedProductId];
  const termsAndConditionsUk =
    selectedProduct &&
    (selectedProduct.infoBubbleText?.termsAndConditions ??
      selectedProduct?.disclaimers?.fullDisclaimer);

  return (
    <Typography className={styles.termsAndConditions} variant="caption5" Component="div">
      <div>
        <span dangerouslySetInnerHTML={{ __html: `<span>${termsAndConditionsUk}</span>` }} />
        <span>
          <a className={styles.privacy} href="/privacy" target="_blank" rel="noopener">
            {strings?.termsPolicy}
          </a>
        </span>
      </div>
    </Typography>
  );
};
